import React from 'react'
import { connect } from 'react-redux'
import { Button } from 'sputnik-ui'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import CircularProgress from '@material-ui/core/CircularProgress'
import TextField from '@material-ui/core/TextField'
import ArrowForwardIcon from '@material-ui/icons/ArrowForward'
import Zoom from '@material-ui/core/Zoom'

import Api from 'utils/api'
import { moveEntry } from 'store/operations'

function Transition(props) {
  return <Zoom direction="up" {...props} />
}

function TransferEntryModal({ open, handleClose, entry, dispatch }) {
  const [step, setStep] = React.useState(1)
  const [streets, setStreets] = React.useState(null)
  const [houses, setHouses] = React.useState(null)
  const [selectedHouse, setSelectedHouse] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const [search, setSearch] = React.useState('')

  const localityUuid = React.useMemo(() => {
    if (!entry || !entry.parents) return null
    const locality = entry.parents.find((p) => p.type === 'locality')
    return locality ? locality.uuid : null
  }, [entry])

  React.useEffect(() => {
    if (open && localityUuid) {
      setStreets(null)
      setHouses(null)
      setStep(1)
      setSelectedHouse(null)
      setSearch('')
      Api.request(`/streets?parent_uuid=${localityUuid}`)
        .then((data) => setStreets(data))
        .catch(() => setStreets([]))
    }
    if (!open) {
      setStep(1)
      setSelectedHouse(null)
      setSearch('')
      setStreets(null)
      setHouses(null)
    }
  }, [open, localityUuid])

  const handleStreetClick = (street) => {
    setSearch('')
    setHouses(null)
    setStep(2)
    Api.request(`/houses?parent_uuid=${street.uuid}`)
      .then((data) => setHouses(data))
      .catch(() => setHouses([]))
  }

  const filteredItems = React.useMemo(() => {
    if (step === 1) {
      return streets
        ? streets.filter((s) =>
            s.full_name.toLowerCase().includes(search.toLowerCase())
          )
        : []
    }
    return houses
      ? houses.filter((h) =>
          h.full_name.toLowerCase().includes(search.toLowerCase())
        )
      : []
  }, [step, streets, houses, search])

  const handleConfirm = () => {
    if (!selectedHouse) return
    setLoading(true)
    dispatch(moveEntry(entry.uuid, selectedHouse.uuid))
      .then(handleClose)
      .catch(() => setLoading(false))
  }

  const handleBack = () => {
    setStep(1)
    setSelectedHouse(null)
    setSearch('')
    setHouses(null)
  }

  const isLoading = step === 1 ? !streets : !houses

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      PaperProps={{ style: { minWidth: 400 } }}
    >
      <DialogTitle>
        {step === 1 ? 'Перенести подъезд — выберите улицу' : 'Выберите дом'}
      </DialogTitle>
      <DialogContent>
        <TextField
          placeholder={step === 1 ? 'Поиск улицы...' : 'Поиск дома...'}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
          style={{ marginBottom: 8 }}
        />
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 16 }}>
            <CircularProgress />
          </div>
        ) : (
          <List dense style={{ maxHeight: 360, overflowY: 'auto' }}>
            {step === 1
              ? filteredItems.map((s) => (
                  <ListItem key={s.uuid} button onClick={() => handleStreetClick(s)}>
                    <ListItemText primary={s.full_name} />
                    <ListItemSecondaryAction>
                      <ArrowForwardIcon style={{ fontSize: 16 }} />
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              : filteredItems.map((h) => (
                  <ListItem
                    key={h.uuid}
                    button
                    selected={selectedHouse && selectedHouse.uuid === h.uuid}
                    onClick={() => setSelectedHouse(h)}
                  >
                    <ListItemText primary={h.full_name} />
                  </ListItem>
                ))}
          </List>
        )}
      </DialogContent>
      <DialogActions style={{ justifyContent: step === 2 ? 'space-between' : 'flex-end' }}>
        {step === 2 && (
          <Button onClick={handleBack} rounded secondary disabled={loading}>
            Назад
          </Button>
        )}
        <div>
          <Button onClick={handleClose} rounded secondary disabled={loading}>
            Отмена
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={loading || !selectedHouse || step !== 2}
            rounded
            primary
          >
            Перенести
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = ({ resources }) => ({
  entry: resources.current,
})

export default connect(mapStateToProps)(TransferEntryModal)
